module.exports = __webpack_public_path__ + "static/media/13a Illegal Grip.6efe55a5.jpg";